// NorvoAi "aurora" dark token system. Keys identical to the previous light
// theme so all `style={{ color: C.text, background: C.surface }}` call-sites
// re-skin without code changes. LITRA brand purple is preserved — both as
// the dark core (#7C3AED) and the bright variant used on dark surfaces
// (#A99BFF) so the LITRA! accent stays recognisable.
export const C = {
  // Surfaces
  pageBg: '#0B0A14',          // page background (near-black violet)
  surface: '#100E1D',         // raised cards / sections
  surfaceAlt: '#1A1729',      // slightly lifted alt surface
  // LITRA / brand violet (kept — brightened for dark use)
  purple: '#A99BFF',          // bright violet — used as text/icon accent on dark
  purpleDark: '#7C3AED',      // LITRA core (unchanged) — kept for gradient ends + brand chips
  purpleLight: '#3D3162',     // borders / dividers tinted violet
  purplePale: '#1B1530',      // very subtle violet-tinted background
  // Aurora blue (alias to violet on this palette)
  blue: '#A99BFF',
  blueDark: '#7C6FCD',
  blueLight: '#3D3162',
  bluePale: '#1B1530',
  // Aurora rosa
  rose: '#F0A5C8',
  roseDark: '#D98FA8',
  roseLight: '#4D2C3E',
  rosePale: '#1F1822',
  // Lines / borders
  border: '#1F1B2C',
  borderMid: '#2A2540',
  // Ink scale (text)
  text: '#F4F1FF',            // primary
  textMid: '#D8D2EF',         // body / secondary
  muted: '#85809F',           // faint / captions, AA on dark cards
  // Status (aurora-tuned — mint/amber/rose stay readable on dark)
  success: '#4FD1C5',
  successPale: '#0F1F1A',
  danger: '#F47A8C',
  dangerPale: '#1F1518',
  warning: '#E4B26B',
  warningPale: '#1F1B12',
  // Editor surface (write/edit field)
  editorBg: '#100E1D',
  editorBorder: '#1F1B2C',
} as const

export const G = {
  // Violet → rosa: primary CTA / key accents.
  primary: `linear-gradient(135deg, ${C.purple}, ${C.rose})`,
  // Alias kept for backwards compatibility with previous "blue" gradient calls.
  blue: `linear-gradient(135deg, ${C.purple}, ${C.rose})`,
  // Subtle dark gradient for hover / soft backgrounds.
  soft: `linear-gradient(135deg, ${C.purplePale}, ${C.rosePale})`,
  // Hero atmosphere: layered radial aurora glows over near-black.
  hero: `radial-gradient(60% 50% at 20% 18%, rgba(124, 111, 205, 0.28), transparent 70%), radial-gradient(45% 40% at 82% 78%, rgba(240, 165, 200, 0.20), transparent 75%), radial-gradient(38% 32% at 55% 12%, rgba(79, 209, 197, 0.14), transparent 75%), ${C.pageBg}`,
} as const
